import { html } from "encamp-shared/dist/utils/htmlTypeSafety";
/**
 * Shared base for all email/cover-letter templates. Communication templates use
 * TemplateParams; newly-not-reporting templates use NewlyNotReportingTemplateParams.
 */
export class BaseTemplate {
}
/**
 * Base for communication-based templates (Tier II, Ohio SERC, etc.). Adds
 * rawTemplate, extractVariables, and toTemplate() for the hydrator.
 *
 * Produces HTML output only (no plain-text fallback).
 */
export class EmailTemplate extends BaseTemplate {
    toTemplate() {
        return {
            id: this.id,
            subject: this.subject.bind(this),
            html: this.html.bind(this),
            rawTemplate: this.rawTemplate.bind(this),
            extractVariables: this.extractVariables.bind(this),
        };
    }
    identifierSection(facility) {
        return html `
        ${facility.name}
        <br />
        ${facility.streetAddress1 || ""}
        <br />
        ${facility.city || ""}, ${facility.state || ""}, ${facility.zip || ""}
      `;
    }
    baseHtml({ identifierSection, companyName, isRevision, }) {
        return html `
  <p>To whom it may concern,</p>
  <br />
  <p>As part of our commitment to the environment and safety of our community, please see the attachments for the following facility:</p>
  <br />
  <p>
    ${identifierSection}
  </p>
  <br />
  <p>This${isRevision ? " Revision " : " "}report is filed by Encamp, Inc. on behalf of ${companyName}.</p>
  <br />
  <p>Encamp strives to maintain the most up to date information for our submissions.  If our current information is incorrect or you have had any updates or changes, please email support@encamp.com and let us know.  This will help us ensure that our reports are submitted more accurately and timely on behalf of our customers.</p>
  <br />
  <p>If you have any questions, please reach out to us at 317-450-4557 or email support@encamp.com.</p>
  <br />
  <p>Thanks for keeping our state safe!</p>
  <br />
  <p>
    Best,
    <br />
    The Encamp Compliance Team
  </p>
`;
    }
}
//# sourceMappingURL=baseTemplate.js.map